import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "sticky top-8" }
const _hoisted_2 = { class: "my-8" }
const _hoisted_3 = { href: "/settings/roles/index/" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-semibold" }, "Back", -1)
const _hoisted_5 = { class: "my-11" }
const _hoisted_6 = { class: "max-w-[925px] mx-auto my-16 flex items-start justify-between space-x-6" }
const _hoisted_7 = { class: "overflow-hidden rounded-t-lg" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("thead", { class: "border-b border-gray-200 bg-primary-100" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "px-6 py-6 font-semibold text-left text-neutral-900 whitespace-nowrap" }, [
      /*#__PURE__*/_createElementVNode("span", null, "Permissions")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "px-6 py-6 font-semibold center text-neutral-900 whitespace-nowrap" }, [
      /*#__PURE__*/_createElementVNode("span", null, "Yes")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "px-6 py-6 font-semibold center text-neutral-900 whitespace-nowrap" }, [
      /*#__PURE__*/_createElementVNode("span", null, "No")
    ])
  ])
], -1)
const _hoisted_9 = { class: "bg-white" }
const _hoisted_10 = { class: "px-6 py-4 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_11 = { class: "text-sm font-semibold" }
const _hoisted_12 = { class: "text-sm text-neutral-600" }
const _hoisted_13 = { class: "px-6 py-4 text-sm text-center text-gray-900 whitespace-nowrap" }
const _hoisted_14 = { class: "px-6 py-4 text-sm text-center text-gray-900 whitespace-nowrap" }
const _hoisted_15 = { class: "rounded-t-lg overflow-hidden min-w-[320px]" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("thead", { class: "border-b border-gray-200 bg-primary-100" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "px-6 py-6 font-semibold text-left text-neutral-900 whitespace-nowrap" }, [
      /*#__PURE__*/_createElementVNode("span", null, "Personnel with this role")
    ])
  ])
], -1)
const _hoisted_17 = {
  key: 0,
  class: "bg-white"
}
const _hoisted_18 = { class: "px-6 py-4 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_19 = { class: "text-sm font-semibold" }
const _hoisted_20 = { class: "text-sm text-neutral-600" }
const _hoisted_21 = {
  key: 1,
  class: "bg-white"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("tr", { class: "border-b border-gray-200" }, [
  /*#__PURE__*/_createElementVNode("td", { class: "px-6 py-4 text-sm text-gray-900 whitespace-nowrap" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-semibold" }, "No Record Found")
  ])
], -1)
const _hoisted_23 = [
  _hoisted_22
]

import { ref, onMounted } from 'vue';
import UserLayout from '@/layouts/UserLayout.vue';
import ButtonComponent from '@/components/buttons/ButtonComponent.vue';
import TabComponent from '@/components/partials/TabComponent.vue';
import { CheckIcon } from '@heroicons/vue/24/outline';

import Roles from "@/classes/Roles";

import { useRoute, useRouter } from "vue-router";
import ArrowLeftIcon from "@/components/icons/arrowLeftIcon.vue";


interface PermissionChecklistInterface {
    description: string,
    has_permission: boolean,
    label: string,
    name: string,
}

interface PersonnelsInterface {
    name: string,
    office_name: string,
}

interface sampleDataInfo {
    module: string,
    description: string,
    status: boolean,
}

interface sampleRoleInfo {
    name: string,
    office: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewPage',
  setup(__props) {

const permissionChecklist = ref<PermissionChecklistInterface[]>([]);
const personnelList = ref<PersonnelsInterface[]>([]);

const route = useRoute();


const init = ():void => {
    
    Roles.show(parseInt(route.params.role))
        .then(({data}) => {
            personnelList.value = data.item.assigned_personels;
            permissionChecklist.value = data.permission_checklist
        })
        .catch((error) => {
            console.log(error);
        })

}

onMounted(() => {
    init()
})


const sampleData = ref<sampleDataInfo[]> ([
    { 
        module: 'Manage Dashboard',
        description: 'Allow the Admin to access the dashboard',
        status: true
    },
    { 
        module: 'Manage Patient',
        description: 'Allow the Admin to access the patient',
        status: false
    },
    { 
        module: 'Manage Intervention',
        description: 'Allow the Admin to access the intervention',
        status: false
    },
    { 
        module: 'Manage Office',
        description: 'Allow the Admin to access the office',
        status: true
    },
    { 
        module: 'Manage Personnel',
        description: 'Allow the Admin to access the personnel',
        status: true
    },
]);

const sampleRoleData = ref<sampleRoleInfo[]> ([
    { 
        name: 'John Doe',
        office: 'Child Protection Office 1'
    },
    { 
        name: 'James Doe',
        office: 'Child Protection Office 1'
    },
    { 
        name: 'Jackson Doe',
        office: 'Child Protection Office 2'
    },
    { 
        name: 'Elizabeth Cruz',
        office: 'Child Protection Office 3'
    },
    { 
        name: 'Kira Cruz',
        office: 'Child Protection Office 3'
    },
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, { hasLeftCon: true }, {
    leftContent: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("a", _hoisted_3, [
            _createVNode(ButtonComponent, { customClass: "tertiary text-black hover:text-primary-600 transition" }, {
              default: _withCtx(() => [
                _createVNode(ArrowLeftIcon, { class: "object-contain w-6 h-6 mr-2" }),
                _hoisted_4
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("table", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("tbody", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(permissionChecklist.value, (item) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.name,
                    class: "border-b border-gray-200"
                  }, [
                    _createElementVNode("td", _hoisted_10, [
                      _createElementVNode("p", _hoisted_11, _toDisplayString(item.label), 1),
                      _createElementVNode("p", _hoisted_12, _toDisplayString(item.description), 1)
                    ]),
                    _createElementVNode("td", _hoisted_13, [
                      (item.has_permission)
                        ? (_openBlock(), _createBlock(_unref(CheckIcon), {
                            key: 0,
                            class: "w-4 h-4 text-primary-600 mx-auto stroke-[3px]"
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_14, [
                      (!item.has_permission)
                        ? (_openBlock(), _createBlock(_unref(CheckIcon), {
                            key: 0,
                            class: "w-4 h-4 text-primary-600 mx-auto stroke-[3px]"
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("table", _hoisted_15, [
              _hoisted_16,
              (personnelList.value.length > 0)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_17, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(personnelList.value, (personnel) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: personnel.name,
                        class: "border-b border-gray-200"
                      }, [
                        _createElementVNode("td", _hoisted_18, [
                          _createElementVNode("p", _hoisted_19, _toDisplayString(personnel.name), 1),
                          _createElementVNode("p", _hoisted_20, _toDisplayString(personnel.office_name), 1)
                        ])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_21, _hoisted_23))
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})